import { RootState } from '../index';

export const getTeammatesKeyword = (state: RootState) => state.teammates.keyword;

export const getTeammatesSort = (state: RootState) => state.teammates.sortBy;

export const getCustomPermissionModalShown = (state: RootState) => state.teammates.customPermissionFor;
